/**
 * @module History
 */
import {ClientApplication} from '../../../client';
import {actionWrapper, ActionSet} from '../../helper';
import {ComplexDispatch, Group, MetaAction} from '../../types';
import {
  invalidActionType,
  invalidPayload,
  throwError,
  ActionType as ErrorActionType,
  ErrorAction,
  Message as ErrorMessage,
} from '../../Error';
import {isValidAbsolutePath, isValidRelativePath} from '../helper';
import {Action, ActionType, Payload} from './types';

export interface HistoryAction extends MetaAction {
  payload: Payload;
}

export function push(payload: Payload): HistoryAction {
  return actionWrapper({
    payload,
    group: Group.Navigation,
    type: ActionType.PUSH,
  });
}

export function replace(payload: Payload): HistoryAction {
  return actionWrapper({
    payload,
    group: Group.Navigation,
    type: ActionType.REPLACE,
  });
}

export function validationError(action: HistoryAction | MetaAction): undefined | ErrorAction {
  let payload;
  switch (action.type) {
    case ActionType.REPLACE:
    case ActionType.PUSH:
      payload = (action as HistoryAction).payload;
      if (payload === undefined) {
        return invalidPayload(action, ErrorMessage.MISSING_PAYLOAD);
      }

      return isValidAbsolutePath(payload.path) || isValidRelativePath(payload.path)
        ? undefined
        : invalidPayload(
            action,
            'Invalid path provided. Expected a relative or absolute https or http path',
          );
    default:
      return invalidActionType(action);
  }
}

export class History extends ActionSet implements ComplexDispatch<string> {
  constructor(app: ClientApplication<any>) {
    super(app, 'History', Group.Navigation);
  }

  get payload() {
    return {id: this.id};
  }

  dispatch(type: Action, path: string) {
    const payload = {...this.payload, path};
    switch (type) {
      case Action.PUSH:
        this.app.dispatch(push(payload));
        break;

      case Action.REPLACE:
        this.app.dispatch(replace(payload));
        break;

      default:
        throwError(
          ErrorActionType.INVALID_ACTION_TYPE,
          actionWrapper({
            type,
            group: this.group,
          }),
        );
    }

    return this;
  }
}

export function create(app: ClientApplication<any>) {
  return new History(app);
}



// WEBPACK FOOTER //
// ./src/actions/Navigation/History/actions.ts